    /*
        TO-DO: 
        Make the cache smart enough to handle "shared fetching" when window resize happens; 
        currently all images individually try to fetch a new image, 
        they should communicate to determine the highest resolution and then agree to only fetch that one
    */
export const cache = {};